'use client';

import React, { useMemo } from 'react';

import { FundingKey } from '@bytel/leviator';
import { Divider, Justify, Text, TextLevels, TypographyBold, View } from '@bytel/trilogy-react';

import { InlinePrice } from '@components/inline-price';

import { PricesDetails, getFundingLabels } from '@product-detail/helpers';

type TicketFundingProps = {
    prices: PricesDetails;
};

export function TicketFunding({ prices }: Readonly<TicketFundingProps>) {
    const { productPrices, funding } = prices;

    const isYounitedFunding = useMemo(
        () =>
            funding &&
            (funding.type === FundingKey.YOUNITED_X3 ||
                funding.type === FundingKey.YOUNITED_X12 ||
                funding.type === FundingKey.YOUNITED_X24 ||
                funding.type === FundingKey.YOUNITED_X36 ||
                funding.type === FundingKey.SWAPPY_X36),

        [funding?.type],
    );

    if (!funding || funding.installmentCount <= 0) return null;

    return (
        <>
            <Divider />
            <View flexable justify={Justify.SPACE_BETWEEN}>
                <div>
                    <Text typo={TypographyBold.TEXT_WEIGHT_SEMIBOLD} level={TextLevels.TWO} marginless>
                        {getFundingLabels(funding.type)} x{funding.installmentCount} mois{' '}
                        {funding.interestAmount > 0 ? 'avec frais' : 'à 0%'}
                    </Text>
                    {isYounitedFunding && (
                        <Text level={TextLevels.THREE} marginless>
                            Prélevés par Younited
                        </Text>
                    )}
                </div>
                {productPrices.fundingMonthlyAmount > 0 && (
                    <InlinePrice level={TextLevels.TWO} amount={productPrices.fundingMonthlyAmount} period='mois' />
                )}
            </View>
        </>
    );
}
